'use client';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { getAllListItems } from '../helpers/get-all-list-items';

type UseGetAllListItemsReturn<TItemDto> = {
    data: TItemDto[];
    isLoading: boolean;
    reload: () => void;
    refetch: () => void;
};

/**
 * @deprecated TODO: This should be moved to another package. Maybe api?
 *
 * The item type is inferred straight from the list response's `_embedded` collections rather than
 * from a `keyof` over a conditional type: a conditional in a type-parameter *constraint* is not
 * resolved while the other parameters are still being inferred, which collapsed `listAccessor` to
 * `never` at every call site.
 */
export function useGetAllListItems<TItem>(
    queryFn: (page: number) => Promise<{ _page_count?: number; _embedded?: Record<string, TItem[]> } | null>,
    listAccessor: string,
    dependencies?: (string | unknown)[],
    options?: {
        enabled?: boolean;
        staleTime?: number;
        refetchInterval?: number | false;
        refetchIntervalInBackground?: boolean;
        refetchOnMount?: boolean | 'always';
        refetchOnWindowFocus?: boolean;
        refetchOnReconnect?: boolean;
    }
): UseGetAllListItemsReturn<TItem> {
    const [uuid] = useState(uuidv4());
    const queryKey = (dependencies?.length ?? 0) > 0 ? dependencies : [uuid];
    const {
        data = [],
        refetch,
        isLoading
    } = useQuery<TItem[]>({
        queryKey: queryKey ?? [],
        queryFn: async () => {
            return (await getAllListItems({
                queryFn: queryFn,
                listAccessor: listAccessor,
                page: 1
            })) as TItem[];
        },
        ...options
    });

    function reload() {
        // remove();
        refetch();
    }

    return {
        data: data || [],
        isLoading: isLoading,
        reload: reload,
        refetch: refetch
    };
}
